import React from 'react';
import { Link } from 'system/base/Link';

type Props = {
  address: string;
};

const EmailAddress = ({ address }: Props) => (
  <Link href={`mailto:${address}`} className="pii">
    {address}
  </Link>
);

export default EmailAddress;
